import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDeveloperStudios } from "../../services/developerService";

function AdminDeveloperStudios() {
  const navigate = useNavigate();
  const [studios, setStudios] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    getDeveloperStudios()
      .then((rows) => {
        if (!cancelled) setStudios(rows);
      })
      .catch(() => {
        if (!cancelled) setError("Could not load developer studios.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const visible = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return studios;
    return studios.filter((studio) =>
      [studio.studioName, studio.name, studio.username, studio.email, studio.id]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(needle)
    );
  }, [query, studios]);

  return (
    <div className="tab-content">
      <div className="panel-header">
        <div>
          <h2>Developer Dashboards</h2>
          <p>Open a studio dashboard to review games, reports, and playtests as that developer.</p>
        </div>
      </div>
      <input
        className="admin-studio-search"
        type="search"
        value={query}
        placeholder="Search studio, name, or email"
        onChange={(event) => setQuery(event.target.value)}
      />
      {loading && <p>Loading studios...</p>}
      {error && <p>{error}</p>}
      {!loading && !error && (
        <div className="admin-studio-list">
          {visible.map((studio) => (
            <button
              key={studio.id}
              type="button"
              className="admin-studio-row"
              onClick={() => navigate(`/admin/studio/${studio.id}`)}
            >
              <span>
                <strong>{studio.studioName || studio.name || studio.username}</strong>
                <small>
                  {studio.email || "No email"} · ID {studio.id}
                </small>
              </span>
              <span className="admin-btn admin-btn--ghost">Open dashboard</span>
            </button>
          ))}
          {visible.length === 0 && <p>No studios match that search.</p>}
        </div>
      )}
    </div>
  );
}

export default AdminDeveloperStudios;
